<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const teaserContentVariants = cva('flex flex-col gap-2 w-full relative', {
  variants: {
    variant: {
      'teaser-group-single-big': 'inverted absolute bottom-0 left-0 right-0',
      'teaser-group-single-small': 'flex-1 bottom-0',
      'teaser-group-double-big': 'inverted absolute bottom-0 left-0 right-0',
      'teaser-group-double': '',
      'teaser-group-triple': '',
      'teaser-group-triple-first': '',
      'teaser-group-triple-other': 'flex-1',
      'teaser-group-quadruple': 'flex-1'
    }
  }
})

type TeaserContentProps = VariantProps<typeof teaserContentVariants>

defineProps<{
  twClass?: string,
  variant: TeaserContentProps['variant']
}>()
</script>

<template>
  <div :class="classMerge(teaserContentVariants({ variant }), twClass)">
    <slot />
  </div>
</template>
